import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {DialogPopupRodizioVeiculoComponent} from './dialog-popup-rodizio-veiculo.component';
import {SharedComponentsModule} from '../shared-components.module';



@NgModule({
  declarations: [
    DialogPopupRodizioVeiculoComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    SharedComponentsModule
  ],
  entryComponents: [DialogPopupRodizioVeiculoComponent]
})
export class DialogPopupRodizioVeiculoModule { }
